/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient, handleTokenAuth } from './api'
import { handleError } from './error';

export const loadReportingFrameworks = () => (dispatch, getState) => {

  const reportingFrameworkState = getState().reportingFrameworks;
  if (reportingFrameworkState.loaded && reportingFrameworkState.reportType === 'taxonomy') {
    return;
  }

  dispatch({ type: actionTypes.LOADING_REPORTING_FRAMEWORKS, reportType: 'taxonomy' });

  const options = handleTokenAuth(getState);

  apiClient.get('/reporting-frameworks/map', options)
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_REPORTING_FRAMEWORKS,
        data: response.data.data,
        reportType: 'taxonomy'
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_REPORTING_FRAMEWORKS))
};

export const loadReportingFrameworksByPrimaryConnections = () => (dispatch, getState) => {

  const reportingFrameworkState = getState().reportingFrameworks;
  if (reportingFrameworkState.loaded && reportingFrameworkState.reportType === 'primary-connections') {
    return;
  }

  dispatch({ type: actionTypes.LOADING_REPORTING_FRAMEWORKS, reportType: 'primary-connections' });

  const options = handleTokenAuth(getState);

  apiClient.get('/reporting-frameworks/map/adaptor', options)
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_REPORTING_FRAMEWORKS,
        data: response.data.data,
        reportType: 'primary-connections'
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_REPORTING_FRAMEWORKS))
};
